

let allColors = document.querySelectorAll('.colorlist label')
var getData = function () {
    var parent =
        this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    var get_selector = parent.getAttribute("data-selector");
    var get_color = this.getAttribute("data-opt-color");
    var handle = parent.getAttribute("data-product-handle");
    var limit = parent.getAttribute("data-id");
    
    let size_selector = document.querySelector(
        '[data-selector="' +
            get_selector +
            '"][data-product-handle="' +
            handle +
            '"][data-id="' +
            limit +
            '"] [data-color-sizes="' +
            get_color +
            '"]'
    );

    var actives = parent.querySelectorAll(".active");
    [].forEach.call(actives, function (elem) {
        elem.classList.remove("active");
    });

    if (size_selector) size_selector.classList.add("active");
    document
        .querySelector(
            '[data-selector="' +
                get_selector +
                '"][data-product-handle="' +
                handle +
                '"][data-id="' +
                limit +
                '"] [data-color-price="' +
                get_color +
                '"]'
        )
        .classList.add("active");
    document
        .querySelector(
            '[data-selector="' +
                get_selector +
                '"][data-product-handle="' +
                handle +
                '"][data-id="' +
                limit +
                '"] [data-color-title="' +
                get_color +
                '"]'
        )
        .classList.add("active");
    document
        .querySelector(
            '[data-selector="' +
                get_selector +
                '"][data-product-handle="' +
                handle +
                '"][data-id="' +
                limit +
                '"] [data-color-imgs="' +
                get_color +
                '"]'
        )
        .classList.add("active");
    document
        .querySelector(
            '[data-selector="' +
                get_selector +
                '"][data-product-handle="' +
                handle +
                '"][data-id="' +
                limit +
                '"] [data-opt-color-selected="1"]'
        )
        .setAttribute("data-opt-color-selected", "0");

    this.setAttribute("data-opt-color-selected", "1");
};
for (var i = 0; i < allColors.length; i++) {
allColors[i].addEventListener('click', getData, false);
}